module.exports = __webpack_public_path__ + "static/fonts/Step1b.svg";